// removed by extract-text-webpack-plugin
module.exports = {"messageContainer":"ErrorList--messageContainer--3T2QGUT0","messageList":"ErrorList--messageList--2SpBaNQv","messageIcon":"ErrorList--messageIcon--20AEcBxj","actionContainer":"ErrorList--actionContainer--3BN9C79h"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/ErrorList/ErrorList.css
// module id = 1174
// module chunks = 2